export default __webpack_public_path__ + "static/kbouw-new-7c22522e8667f5cc77057f5de7ec43aa.png";